// we only accept what we generate on server, which is
// the javascript-toISOString format
const STRING_RE = /^\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d\.\d\d\dZ$/;

export function stringToDate(dateString) {
    const isValidString = STRING_RE.exec(dateString);

    if (!isValidString) {
        throw new Error('stringToDate: invalid date-string:' + dateString);
    }

    const unixTimeMilliseconds = Date.parse(dateString);

    // we get NaN if the date was invalid
    if (isNaN(unixTimeMilliseconds)) {
        throw new Error('stringToDate: invalid date-string:' + dateString);
    }

    return new Date(unixTimeMilliseconds);
}

export function anyToDate(dateThing) {
    if (dateThing instanceof Date) {
        return dateThing;
    } else {
        if (typeof dateThing === 'string') {
            return stringToDate(dateThing);
        } else {
            throw new Error('anyToDate: got non-convertible thing:' + dateThing);
        }
    }
}

/**
 * Convert local datum '2018-10-23' to Date() object where time
 * is set to '00:00:00.000' in local (browser) timezone.
 */
export function localDatumToDate(dateString) {
    return dateString ? new Date(Date.parse(dateString)) : null;
}

export function dateToString(date) {
    return date.toISOString();
}
